<template>
  <div>
    <!-- header area -->
    <div class="content no-top-padding header-area">
      <div class="title">
        <h1>Device Charts</h1>
        <custom-date-picker
          :callback-func="handleOnChartReady"
        ></custom-date-picker>
      </div>

      <div class="chart-section">
        <custom-pie-chart
          :loading="loadingChartData"
          :data="pieChart"
          @onReady="handleOnChartReady"
        ></custom-pie-chart>
      </div>
      <!-- custom chart -->
      <custom-chart
        :loading="loadingChartData"
        :data="batteryData"
        @onReady="handleOnChartReady"
      ></custom-chart>
    </div>

    <!-- footer area -->
    <div class="footer-area">
      <div class="content">
        <!-- <h2>System status in VRM</h2> -->
        <!-- <div class="grid grid-1">
          <custom-box
            value="35W"
            title="Devices"
            icon="fa-calendar-plus-o "
            iconLabel="25C"
            color="#4790d0"
          ></custom-box>
          <custom-box
            value="0W"
            title="Unavailable"
            icon="fa-hourglass-end"
            color="#f7ab3e"
          ></custom-box>
          <custom-box
            value="0W"
            title="Available"
            icon="fa-hourglass-end"
            color="#72b84ce6"
          ></custom-box>
          <custom-grid-box
            value="200.09W"
            leftText="To Grid"
            rightText="From Grid"
          ></custom-grid-box>
        </div> 
        <div class="grid grid-2">
          <custom-box
            value="100.0%"
            title="Error"
            icon="fa-battery-quarter "
            iconLabel="Idle"
            voltage="53.99V"
            color="#fa716f"
            current="1.40A"
          ></custom-box>
          <custom-geo-box value="100.0%" title="Battery"></custom-geo-box>
        </div>-->
        <div class="chart-section">
          <custom-chart
            :loading="loadingChartData"
            :data="inverterData"
            @onReady="handleOnChartReady"
          ></custom-chart>
        </div>

        <div class="chart-section">
          <custom-chart
            :loading="loadingChartData"
            :data="energyData"
            @onReady="handleOnChartReady"
          ></custom-chart>
        </div>

        <!-- <div class="chart-section">
          <custom-pie-chart
            :loading="loadingChartData"
            :data="pieChart"
            @onReady="handleOnChartReady"
          ></custom-pie-chart>
        </div>-->
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters } from "vuex";
import customBox from "./components/customBox";
import customGridBox from "./components/customGridBox";
import customGeoBox from "./components/customGeoBox";
import customChart from "./components/customChart";
import customDatePicker from "./components/customDatePicker";
import customPieChart from "./components/customPieChart";

import Vue from "vue";

import {
  Card,
  Select,
  Option,
  OptionGroup,
  Input,
  DatePicker,
  InputNumber,
} from "element-ui";

import { HTTP as IOTHTTP } from "../../../store/actions";
import moment from "moment";

Vue.use(Card);
Vue.use(Select);
Vue.use(Option);
Vue.use(OptionGroup);
Vue.use(Input);
Vue.use(InputNumber);

export default {
  data() {
    return {
      inverterId: null,
      batteryData: {},
      inverterData: {},
      energyData: {},
      pieChart: {},
      loadingChartData: false,
      batteryDataLabel: [
        {
          type: "value",
          name: " %",
          min: 0,
          max: 100,
          interval: 20,
          axisLabel: {
            formatter: "{value}",
            color: "#959490",
          },
          splitLine: {
            lineStyle: {
              color: "transparent",
            },
          },
        },
      ],
    };
  },
  computed: {
    ...mapGetters([
      "getUserById",
      "getDeviceById",
      "getUsers",
      "getDummy",
      "getDevices",
      "getUserSession",
    ]),
  },
  components: {
    // GreyPagination
    "custom-box": customBox,
    "custom-grid-box": customGridBox,
    "custom-geo-box": customGeoBox,
    "custom-chart": customChart,
    "custom-pie-chart": customPieChart,
    "el-date-picker": DatePicker,
    "custom-date-picker": customDatePicker,
  },
  methods: {
    async handleOnChartReady(
      upperLimit = null,
      lowerLimit = null,
      limit = 100
    ) {
      let container = this;
      try {
        container.loadingChartData = true;
        // var inverterId = "411241";
        var headers = {
          "Content-Type": "application/plain",
        };

        const data = {
          TableName: "HourlyChart",
          KeyConditionExpression:
            "DeviceID = :key and DeviceTimeStamp BETWEEN :up AND :down",
          ExpressionAttributeValues: {
            ":key": `${this.$route.params.deviceId}`,
            ":up":
              upperLimit ||
              moment(new Date().toISOString()).startOf("day").toDate(),
            ":down": lowerLimit || new Date().toISOString(),
          },
          Limit: 1440,
          ScanIndexForward: true,
        };

        const resp = await IOTHTTP.post(`/devicedata`, data, {
          headers,
        });

        const DevData = resp.data.Items.map((v) => ({
          ...v,
          EnergyData: v.FV >= 1.76 || v.FV == 1.11? v.EnergyData.Data[0] : v.EnergyData,
        }));
        // let { FV } = DevData;
        // console.log({ DevData });
        this.batteryData = {
          title: "Battery Level/Load (%)",
          timeStamps: this.getTimeLabel(DevData),
          seriesData: this.batteryDataChart(DevData),
          yAxisLabel: this.batteryDataLabel,
        };
        this.inverterData = {
          title: "PV Yield/System Output",
          timeStamps: this.getTimeLabel(DevData),
          seriesData: this.inverterDataChart(DevData),
          yAxisLabel: [
            {
              type: "value",
              name: "kW",
              min: 0,
              // max: 100,
              // interval: 10,
              splitNumber: 3,
              axisLabel: {
                formatter: "{value}",
                color: "#959490",
              },
              splitLine: {
                lineStyle: {
                  // color: "#eee"
                },
              },
            },
          ],
        };
        this.energyData = {
          title: "Energy Data",
          timeStamps: this.getTimeLabel(DevData),
          seriesData: this.energyDataChart(DevData),
        };
        this.pieChart = {
          title: "Energy Source(kW)",
          data: this.pieChartData(DevData),
        };
        container.loadingChartData = false;
      } catch (error) {
        console.log("********************************************************");
        console.log(error);
        container.loadingChartData = false;
        console.log("********************************************************");
      }
      // this.batteryChart(DevData, this.getTimeLabel(DevData));
    },
    batteryDataChart(displayData) {
      // console.log({ displayData });
      const seriesData = [
        ...this.arrBatteryData({
          data: displayData,
          color: "green",
          type: "line",
        }),
        ...this.arrDecoration({
          data: this.computeLoadPercent(displayData, "max"),
          color: "red",
          title: "Output Load",
        }),
        {
          name: "Output Load (avg)",
          legend: "Output Load",
          type: "bar",
          smooth: false,
          symbol: "none",
          // stack: "ol",
          barGap: 0,
          // areaStyle: {},
          itemStyle: {
            color: "rgba(16, 156, 241,0.4)", // blue
          },
          // yAxisIndex: 1,
          data: this.computeLoadPercent(displayData, "avg"),
        },
        // {
        //   name: "Output Load (min)",
        //   legend: "Output Load (min)",
        //   type: "bar",
        //   barGap: 0,
        //   smooth: false,
        //   symbol: "none",
        //   // stack: "ol",
        //   // areaStyle: {},
        //   itemStyle: {
        //     color: "rgba(255, 185, 70,0.47)" // yellow
        //   },
        //   // yAxisIndex: 1,
        //   data: this.computeLoadPercent(displayData, "min")
        // }
      ];

      return seriesData;
    },
    inverterDataChart(displayData) {
      const seriesData = [
        ...this.arrPvChargingPower({
          data: displayData,
          color: "blue",
          type: "bar",
        }),
        ...this.arrDecoration({
          data: this.computeACOAP(displayData, "max"),
          color: "green",
          title: "Output Power",
        }),
        // ...this.arrACOutputCurrent({
        //   data: displayData,
        //   color: "red",
        //   type: "line"
        // })
      ];

      return seriesData;
    },
    energyDataChart(displayData) {
      console.log({ displayData });
      const seriesData = [
        ...this.arrGeneratednX({
          data: displayData,
          color: "blue",
          type: "bar",
        }),
        ...this.arrConOnGrd({
          data: displayData,
          color: "yellow",
          type: "bar",
        }),
        ...this.arrConOffGrd(displayData, "red"),
      ];

      return seriesData;
    },

    pieChartData(displayData) {
      const result = [
        {
          value: this.computePieChartData(displayData, "pvSource"),
          name: "PV",
          itemStyle: {
            color: "rgba(16, 156, 241,0.4)", // blue
          },
        },
        {
          value: this.computePieChartData(displayData, "gridSource"),
          name: "Grid",
          itemStyle: {
            color: "rgba(255, 185, 70,0.47)", // yellow
          },
        },
        {
          value: this.computePieChartData(displayData, "batterySource"),
          name: "Battery",
          itemStyle: {
            color: "rgba(250, 113, 111, 0.46)", // red
          },
        },
      ];
      return result;
    },

    computePieChartData(arrData, key) {
      const result = arrData.filter((item) => {
        if (!item["loadEnergySource"] || !item["loadEnergySource"][key]) return;
        return item["loadEnergySource"][key];
      });

      if (result.length < 1) return;

      return Math.round(
        result.reduce((total, item) => {
          return total + item["loadEnergySource"][key];
        }, 0) /
          result.length /
          1000
      );
    },

    // computePieChartData(arrData, key) {
    //   const objData = arrData[arrData.length - 1];
    //   console.log(objData["loadEnergySource"][key]);
    //   if(!objData["loadEnergySource"] || !objData["loadEnergySource"][key]) return
    //   return objData["loadEnergySource"][key];
    // },

    // @todo: this should be extracted to a global util class
    computeBatteryData(arrData, str) {
      return arrData.map((item) => {
        if (item["Battery"] && item["Battery"]["SOC"]) {
          switch (str) {
            case "max":
              return item["Battery"]["SOC"]["max"];
            case "min":
              return item["Battery"]["SOC"]["min"];
            case "avg":
              return item["Battery"]["SOC"]["avg"];
            default:
              return item["Battery"]["SOC"]["max"];
          }
        } else {
          return 0;
        }
      });
    },

    // @todo: this should be extracted to a global util class
    computePVChargingPower(arrData, version = "v3", str) {
      return arrData.map((item) => {
        // const powerKey = `PVCgP${version == "v4" ? "1" : ""}`;
        let chgPwr = item.InverterData["PVCgP"] || item.InverterData["PVCgP1"];
        if (chgPwr) {
          switch (str) {
            case "max":
              return chgPwr["max"] / 1000;
            case "min":
              return chgPwr["min"] / 1000;
            case "avg":
              return chgPwr["avg"] / 1000;
            default:
              return chgPwr["max"] / 1000;
          }
        } else {
          return 0;
        }
      });
    },

    computeLoadPercent(arrData, str) {
      return arrData.map((item) => {
        if (item["InverterData"]["OL%"]) {
          switch (str) {
            case "max":
              return item["InverterData"]["OL%"]["max"];
            case "min":
              return item["InverterData"]["OL%"]["min"];
            case "avg":
              return item["InverterData"]["OL%"]["avg"];
            default:
              return item["InverterData"]["OL%"]["max"];
          }
        } else {
          return 0;
        }
      });
    },

    computeEnergyData(arrData, key) {
      return arrData.map((item) => {
        if (!item["EnergyData"] || !item["EnergyData"][key]) return;
        return item["EnergyData"][key] / 1000;
      });
    },

    arrDecoration({ data, color, title }) {
      return [
        // {
        //   name: title,
        //   // legend: title,
        //   type: "pictorialBar",
        //   symbol: "rect",
        //   itemStyle: {
        //     color: this.getColor(color, "0.1")
        //   },
        //   symbolRepeat: true,
        //   symbolSize: [12, 4],
        //   symbolMargin: 1,
        //   data: data
        // },
        {
          name: title,
          legend: title,
          type: "line",
          smooth: true,
          symbol: "emptyCircle",
          showAllSymbol: true,
          symbolSize: 10,
          barGap: 0,
          stack: "ol",
          itemStyle: {
            color: this.getColor(color, "0.5"),
          },
          data: data,
        },
      ];
    },

    arrBatteryData({ data, color, type }) {
      return [
        {
          name: "Battery Level",
          legend: "Battery Level",
          type: type,
          smooth: true,
          // symbol: "none",
          stack: "battery",
          itemStyle: {
            color: this.getColor(color, "0.4"),
          },
          data: this.computeBatteryData(data, "max"),
        },
        {
          name: "Battery Level (avg)",
          // legend: "Battery Level",
          type: type,
          smooth: true,
          // symbol: "none",
          // areaStyle: {},
          stack: "battery",
          areaStyle: {
            color: this.getColor(color, "0.2"),
          },
          itemStyle: {
            color: this.getColor(color, "0.8"),
          },
          data: this.computeBatteryData(data, "avg"),
        },
        // {
        //   name: "Battery Data",
        //   // legend: "Battery Level",
        //   type: type,
        //   smooth: true,
        //   // symbol: "none",
        //   stack: "battery",
        //   areaStyle: {
        //     color: this.getColor(color, "0.2")
        //   },
        //   // areaStyle: {},
        //   itemStyle: {
        //     color: this.getColor(color, "0.2")
        //   },
        //   data: this.computeBatteryData(data, "min")
        // }
      ];
    },

    arrPvChargingPower({ data, color, type }) {
      return [
        {
          name: "PV Yield",
          legend: "PV Yield",
          type: type,
          barGap: 0,
          smooth: true,
          symbol: "none",
          // stack: "pvcp",
          areaStyle: {},
          itemStyle: {
            color: this.getColor(color, "0.5"),
          },
          lineStyle: {
            width: 1,
          },
          data: this.computePVChargingPower(
            data,
            this.$route.params.version,
            "max"
          ),
        },
        {
          name: "PV Yield (avg)",
          // legend: "PV Charging Power",
          // legend: "PV Yield (AVG)",
          type: type,
          smooth: true,
          symbol: "none",
          // stack: "pvcp",
          areaStyle: {},
          itemStyle: {
            color: this.getColor("red", "0.5"),
          },
          lineStyle: {
            width: 1,
          },
          data: this.computePVChargingPower(
            data,
            this.$route.params.version,
            "avg"
          ),
        },
        {
          name: "PV Yield (min)",
          // legend: "PV Charging Power",
          type: type,
          smooth: true,
          symbol: "none",
          // stack: "pvcp",
          areaStyle: {},
          itemStyle: {
            color: this.getColor("yellow", "0.5"),
          },
          lineStyle: {
            width: 1,
          },
          data: this.computePVChargingPower(
            data,
            this.$route.params.version,
            "min"
          ),
        },
      ];
    },

    arrACOutputCurrent({ data, color, type }) {
      return [
        {
          name: "Output Power (line)",
          legend: "Output Power (line)",
          type: type,
          smooth: true,
          symbol: "none",
          stack: "acaot",
          areaStyle: {},
          itemStyle: {
            color: this.getColor(color, "0.67"),
          },
          lineStyle: {
            width: 1,
          },
          data: this.computeACOAP(data, "max"),
        },
        {
          name: "AC Output Current (avg)",
          legend: "AC Output Current",
          type: type,
          smooth: true,
          symbol: "none",
          stack: "acaot",
          areaStyle: {},
          itemStyle: {
            color: this.getColor(color, "0.47"),
          },
          lineStyle: {
            width: 1,
          },
          data: this.computeACOAP(data, "avg"),
        },
        {
          name: "AC Output Current (min)",
          legend: "AC Output Current",
          type: type,
          smooth: true,
          symbol: "none",
          stack: "acaot",
          areaStyle: {},
          itemStyle: {
            color: this.getColor(color, "0.27"),
          },
          lineStyle: {
            width: 1,
          },
          data: this.computeACOAP(data, "min"),
        },
      ];
    },

    arrConOnGrd({ data, color, type }) {
      return [
        {
          name: "Consumed On Grid (Year)",
          legend: "Consumed",
          type: type,
          symbol: "rect",
          barWidth: 15,
          itemStyle: {
            color: this.getColor(color, "0.5"),
          },
          symbolRepeat: true,
          stack: "ConOGd",
          areaStyle: {
            color: this.getColor(color, "0.2"),
          },
          // smooth: true,
          // symbol: "emptyCircle",
          // showAllSymbol: true,
          // symbolSize: 15,
          // barGap: 0,
          // itemStyle: {
          //   // color: "rgba(250, 113, 111, 0.7)" // red
          //   color: "rgba(16, 156, 241,0.5)" // blue
          // },
          data: this.computeEnergyData(data, "ConYOGd"),
        },
        {
          name: "Consumed On Grid (Month)",
          // legend: "Consumed",
          type: type,
          stack: "ConOGd",
          symbol: "rect",
          areaStyle: {},
          itemStyle: {
            color: this.getColor(color, "0.4"),
          },
          // smooth: true,
          // symbol: "emptyCircle",
          // showAllSymbol: true,
          // symbolSize: 15,
          // barGap: 0,
          // itemStyle: {
          //   // color: "rgba(250, 113, 111, 0.6)" // red
          // },
          data: this.computeEnergyData(data, "ConMOGd"),
        },
        {
          name: "Consumed On Grid (Week)",
          // legend: "Consumed",
          type: type,
          // smooth: false,
          // symbol: "none",
          stack: "ConOGd",
          symbol: "rect",
          areaStyle: {},
          itemStyle: {
            color: this.getColor(color, "0.3"),
          },
          data: this.computeEnergyData(data, "ConWOGd"),
        },
        {
          name: "Consumed On Grid (Today)",
          // legend: "ConTOGd",
          type: type,
          stack: "ConOGd",
          symbol: "rect",
          areaStyle: {},
          itemStyle: {
            color: this.getColor(color, "0.2"),
          },
          data: this.computeEnergyData(data, "ConTOGd"),
        },
      ];
    },

    arrConOffGrd(displayData, color) {
      return [
        {
          name: "Consumed Off Grid (Year)",
          legend: "Consumed Off Grid (Year)",
          type: "bar",
          smooth: true,
          symbol: "emptyCircle",
          showAllSymbol: true,
          symbolSize: 15,
          stack: "confgd",
          barGap: 0,
          barWidth: 12,
          itemStyle: {
            color: this.getColor(color, "0.5"), // red
          },
          data: this.computeEnergyData(displayData, "ConYfGd"),
        },
        {
          name: "Consumed Off Grid (Month)",
          legend: "ConMOGd",
          type: "bar",
          stack: "confgd",
          // smooth: true,
          // symbol: "emptyCircle",
          // showAllSymbol: true,
          // symbolSize: 15,
          itemStyle: {
            color: this.getColor(color, "0.4"),
          },
          data: this.computeEnergyData(displayData, "ConMfGd"),
        },
        {
          name: "Consumed Off Grid (Week)",
          legend: "ConWOGd",
          stack: "confgd",
          type: "bar",
          // smooth: false,
          // symbol: "none",
          // stack: "ol",
          // barGap: 0,
          // areaStyle: {},
          itemStyle: {
            color: this.getColor(color, "0.3"),
          },
          // yAxisIndex: 1,
          data: this.computeEnergyData(displayData, "ConWfGd"),
        },
        {
          name: "Consumed Off Grid (Today)",
          legend: "ConTOGd",
          type: "bar",
          stack: "confgd",
          // barGap: 0,
          // smooth: false,
          // symbol: "none",
          itemStyle: {
            color: this.getColor(color, "0.2"),
          },
          data: this.computeEnergyData(displayData, "ConTfGd"),
        },
      ];
    },

    arrGeneratednX({ data, color, type }) {
      return [
        {
          name: "Generated (Year)",
          legend: "Generated (Year)",
          type: type,
          smooth: true,
          stack: "gnx",
          areaStyle: {
            color: this.getColor(color, "0.5"),
          },
          itemStyle: {
            color: this.getColor(color, "0.4"),
          },
          barWidth: 18,
          lineStyle: {
            width: 1,
          },
          data: this.computeEnergyData(data, "GnY"),
        },
        {
          name: "Generated (Month)",
          // legend: "ConMOGd",
          type: type,
          smooth: true,
          // symbol: "none",
          stack: "gnx",
          areaStyle: {},
          itemStyle: {
            color: this.getColor(color, "0.3"),
          },
          lineStyle: {
            width: 1,
          },
          data: this.computeEnergyData(data, "GnM"),
        },
        {
          name: "Generated (Week)",
          // legend: "ConWOGd",
          type: type,
          smooth: true,
          symbol: "none",
          stack: "gnx",
          areaStyle: {},
          itemStyle: {
            color: this.getColor(color, "0.2"),
          },
          lineStyle: {
            width: 1,
          },
          data: this.computeEnergyData(data, "GnW"),
        },
        {
          name: "Generated (Today)",
          // legend: "ConTOGd",
          type: type,
          smooth: true,
          symbol: "none",
          stack: "gnx",
          areaStyle: {},
          itemStyle: {
            color: this.getColor(color, "0.1"),
          },
          // lineStyle: {
          //   width: 1
          // },
          data: this.computeEnergyData(data, "GnT"),
        },
      ];
    },

    computeACOAP(arrData, str) {
      return arrData.map((item) => {
        let ACOAP = item.InverterData["ACOAP"] || item.InverterData["ACOAPt"];
        if (ACOAP) {
          if (str) {
            return ACOAP[str] / 1000;
          }
          return ACOAP["max"] / 1000;
        } else {
          return 0;
        }
      });
    },

    roundUp(num) {
      return Math.round(num * 100) / 100;
    },

    getColor(color, opacity) {
      switch (color) {
        case "blue":
          return `rgba(16, 156, 241, ${opacity})`; // blue
        case "red":
          return `rgba(250, 113, 111, ${opacity})`; // red
        case "green":
          return `rgba(114, 184, 76, ${opacity})`; // green
        case "yellow":
          return `rgba(255, 185, 70, ${opacity})`; // yellow
        default:
          return "rgba(${color} ${opacity})";
      }
    },

    getTimeLabel(data) {
      return data.reduce((aggr, c_item) => {
        aggr = [
          ...aggr,
          moment(c_item["DeviceTimeStamp"])
            // .add(1, "hour")
            // .format("h:m:s A")
            .format("D MMM YYYY HH:mm"),
        ];
        return aggr;
      });
    },
  },
  mounted() {
    this.inverterId = this.$route.params.deviceId;
  },
};
</script>

<style lang="scss" scoped>
.title {
  margin-bottom: 50px;
}

.footer-area {
  background-color: #ffffff;
}

.content {
  margin: 0 auto;
  width: 100%;
  max-width: 960px;
  padding: 50px 0;
}

.no-top-padding {
  padding-top: 0;
}

.grid {
  display: grid;
  grid-gap: 20px;
}

.grid-1 {
  grid-template-columns: 0.5fr 0.5fr 1fr;
}

.grid-2 {
  margin-top: 20px;
  grid-template-columns: 0.5fr 1fr 0.5fr;
}

.box {
  background-color: white;
  border: 1px solid #f0f0f0;
  padding: 20px;
  height: 220px;
}

.small {
  display: block;
  margin-top: -10px;
  color: #999;
}

.chart-info {
  display: flex;
  margin-top: 30px;
}

.chart-section {
  margin-bottom: 30px;
}

.info-item {
  display: flex;
  align-items: center;

  i {
    margin-right: 5px;
  }

  & + .info-item {
    margin-left: 30px;
  }

  span {
    font-size: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/dashboard/new.vue